module.exports = __webpack_public_path__ + "media/images/clock-2fc50583998c184a295afb0b207f15f1.svg";